import { createMemo } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ListItemAvatarPropsType } from '~/types/ListItemAvatar'

export default function ListItemAvatar(props: ListItemAvatarPropsType) {
  const avatarClasses = createMemo(() => twMerge('flex items-center justify-center flex-shrink-0', 'w-10 h-10 mr-3', props.class))

  return (
    <div class={avatarClasses()} classList={props.classList}>
      {props.children}
    </div>
  )
}
